import axios from 'axios';
import Vue from 'vue';

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL
Vue.prototype.$axios = axios;

export default axios;